<ng-container *ngComponentOutlet="anfrageLiveSharingComponent"></ng-container>
<div class="h-100 d-flex overflow-y-hidden overflow-x-hidden">
    <prozess-navigation 
        class="navigation" 
        [ngClass]="{ 'collapsed': !showProzessNavigation }" 
        id="resizableLeft">
        <div>
            <app-navigation-item #parent
                *ngFor="let navItem of navItemList"
                [name]="navItem.name"
                [kurzbeschreibung]="navItem.kurzbeschreibung"
                [href]="'./' + navItem.link"
                [isValid]="isFormEnabled && getStatusFor(navItem.id) == 1"
                [isActive]="isCurrentRoute(navItem.abschnitt)"
                [showValidationStatus]="isFormEnabled"
                [formIcon]="navItem.icon"
                [hasChildren]="shouldShowSubsectionsInNavigation(navItem.abschnitt) && navItem.childAbschnitte && navItem.childAbschnitte.length > 0"
                [hasNephews]="hasNephews(navItemList)"
                [isExpanded]="shouldShowSubsectionsInNavigation(navItem.abschnitt) && (isParentOpen(navItem.abschnitt) || isChildAbschnittNotValid(navItem.abschnitt))"
                (click)="onAppNavigationItemClick()"
                >
                <div group *ngIf="shouldShowSubsectionsInNavigation(navItem.abschnitt) && navItem.childAbschnitte && navItem.childAbschnitte.length > 0 && (isParentOpen(navItem.abschnitt) || isChildAbschnittNotValid(navItem.abschnitt))">
                    <app-navigation-item
                        *ngFor="let navItemChild of navItem.children"
                        [name]="navItemChild.name"
                        [kurzbeschreibung]="navItemChild.kurzbeschreibung"
                        [href]="navItemChild.link"
                        [isValid]="isFormEnabled && getStatusFor(navItemChild.id) == 1"
                        [showValidationStatus]="isFormEnabled"
                        [isSubItem]="true"
                        [isActive]="isCurrentRoute(navItem.abschnitt, navItemChild.abschnitt)"
                        [formIcon]="navItemChild.icon"
                        [parentNavItem]="parent"
                        (click)="onAppNavigationItemClick()"
                        >
                    </app-navigation-item>
                </div>
            </app-navigation-item>
        </div>
        <app-navigation-item
            *ngIf="showAbsenden"
            [name]="GetAbsendenText"
            href="./dataprotection"
            [isValid]="isFormEnabled && getStatusFor('dataprotection') == 1"
            [showValidationStatus]="isFormEnabled"
            [hasNephews]="hasNephews(navItemList)"
            [isActive]="isDataprotectionRoute()"
            [formIcon]="'send'"
            (click)="onAppNavigationItemClick()"
            >
        </app-navigation-item>

        <div (mousedown)="draggableSidebar.onMouseDown($event, 'resizableLeft')" class="resize-bar right" [ngClass]="{'hidden' : ! showProzessNavigation}"></div>
    </prozess-navigation>

    <main class="content" id="main-content">
        <div id="topPosition"></div>
        <router-outlet></router-outlet>
    </main>

    <ng-component *ngComponentOutlet="detailSidepaneComponent"></ng-component>
</div>